export const BASE_URL = "https://murojaat.karantin.uz";
export const EXPIRES_DATE = (new Date(Date.now() + (24 * 60 * 60) * 1000)).toUTCString();
